<ion-text>
  <p class="font-text">
    Você preencheu as informações iniciais necessárias para a contratação do serviço de regularização do seu imóvel.
  </p>
  <p class="font-text">
    <span class="text-link" (click)="navegarParaFecharContrato()">Clique aqui</span> para finalizar a contratação do nosso serviço.
  </p>
</ion-text>
